import { render, staticRenderFns } from "./demo-child.vue?vue&type=template&id=e4746e66&"
import script from "./demo-child.vue?vue&type=script&lang=js&"
export * from "./demo-child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports